import { render, staticRenderFns } from "./ItemTile.vue?vue&type=template&id=0cbe83e0&"
import script from "./ItemTile.vue?vue&type=script&lang=ts&"
export * from "./ItemTile.vue?vue&type=script&lang=ts&"
import style0 from "./ItemTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ItemTile.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
